import type { ComponentProps } from 'react';

import { useAgentConversationsStore } from '../../../../store/AgentConversations';
import { SidebarNavLink } from '../SidebarNavLink';

type AssistantNavLinkProps = Omit<
  ComponentProps<typeof SidebarNavLink>,
  'count'
>;

export const AssistantNavLink = (props: Readonly<AssistantNavLinkProps>) => {
  const pendingCount = useAgentConversationsStore(
    (s) => s.pendingUserActionIds.size,
  );
  return <SidebarNavLink {...props} count={pendingCount} />;
};
